
import React, { Component } from 'react'
import Youtube from 'react-youtube'

class Player extends Component {

    constructor(props) {
        super(props)
        this.opts = {
            height: props.height,
            width: props.width,
            playerVars: {
                autoplay: 1,
                showinfo: 0,
                controls: 0,
                rel: 0,
                iv_load_policy: 3,
            }
        }
        this.player = null
        this.playingTime = new Date().getTime()
        this.aboutToCompleteCalled = false
    }

    onReady = (event) => {
        this.player = event.target
        this.playingTime = new Date().getTime()
    }

    onPlay = (ev) => {
        console.log('Reproduciendo player')

        if (this.props.onPlay) {
            this.props.onPlay(ev)
        }
        this.playingTime = new Date().getTime()
        this.aboutToCompleteCalled = false
        this.healthChecker()
        this.adjustVolume()
    }

    onPause = (ev) => {
        if (this.props.onPause) {
            this.props.onPause(ev)
        }
    }

    onEnd = (ev) => {
        if (this.props.onEnd) {
            this.props.onEnd()
        }
        if (this.player) {
            this.player.stopVideo()
        }
    }

    onError = (ev) => {
        if (this.props.onError) {
            this.props.onError(ev)
        }
        if (this.player) {
            this.player.stopVideo()
        }
    }

    onStateChange = () => {

    }

    onPlaybackRateChange = () => {

    }

    onPlaybackQualityChange = () => {

    }

    adjustVolume = () => {
        var volume = 40
        if (!this.props.ad.meanVolume) {
            this.props.ad.meanVolume = -15
        }
        if (this.props.ad.meanVolume) {
            var nVolume = Number(this.props.ad.meanVolume)
            volume = 58.7118004702171 + 4.4276431480635 * nVolume + 0.3250771890878 * Math.pow(nVolume, 2) + 0.0029701484636 * Math.pow(nVolume, 3);
            volume = volume > 100 ? 100 : volume
            volume = volume < 1 ? 1 : volume
        }
        console.log(`Volumen medio: ${this.props.ad.meanVolume}`)
        console.log(`Volumen de youtube: ${volume}`)
        this.player.setVolume(parseInt(volume))
    }

    healthChecker = () => {
        let now = new Date().getTime()
        let playerState = this.player.getPlayerState()
        let remainingTime = this.player.getDuration() - this.player.getCurrentTime()
        
        if(this.props.ad.endSeconds && this.props.ad.endSeconds > 0) {
            remainingTime = this.props.ad.endSeconds - this.player.getCurrentTime()
        } 

        if (playerState === Youtube.PlayerState.PLAYING) {
            this.playingTime = new Date().getTime()
        }

        if (playerState === Youtube.PlayerState.PLAYING && remainingTime < 7 && this.props.aboutToComplete && !this.aboutToCompleteCalled) {
            this.aboutToCompleteCalled = true
            this.props.aboutToComplete()
        }

        if (this.player.getPlayerState() === Youtube.PlayerState.ENDED || remainingTime < 1) {
            this.props.onEnd()
            return
        }

        this.lastTimeout = setTimeout(this.healthChecker, 1000)

    }

    componentWillUnmount = () => {
        if (this.lastTimeout) {
            this.lastTimeout = null
        }
    }

    componentWillReceiveProps = (nextProps) => {
        console.log(`Componente se actualizará`)
        if(nextProps.ad != null && nextProps.ad.startSeconds) {
            this.opts.playerVars.start = nextProps.ad.startSeconds
        }
        /*if(nextProps.ad != null && nextProps.ad.endSeconds) {
            this.opts.playerVars.end = nextProps.ad.endSeconds
        }*/
    }

    componentDidMount = () => {
        
    }

    render = () => {
        return (
            <Youtube
                videoId={this.props.ad.videoId}
                opts={this.opts}
                onReady={this.onReady}
                onPlay={this.onPlay}
                onPause={this.onPause}
                onEnd={this.onEnd}
                onError={this.onError}
                onStateChange={this.onStateChange}
                onPlaybackRateChange={this.onPlaybackRateChange}
                onPlaybackQualityChange={this.onPlaybackQualityChange}
            >
            </Youtube>
        );
    }
}

export default Player


// WEBPACK FOOTER //
// ./src/components/player/Player.js